export function openAIWidget(message?: string) {
  try {
    const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement | null;
    if (btn) btn.click();
    const vapi = (window as any)?.vapi;
    if (vapi && typeof vapi.sendMessage === 'function' && message) {
      // Give the widget time to open and initialize
      setTimeout(() => {
        try {
          vapi.sendMessage(message);
        } catch (e) {
          // Silently ignore if the widget isn't ready
        }
      }, 600);
    }
  } catch (e) {
    // No-op if widget is unavailable
  }
}